import React from 'react';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { Dialog } from 'primereact/dialog';
import { FormMicThermometer } from './FormMicThermometer';
export const DialogMicThermometer = ({
  visible,
  setVisible,
  handleInputChange,
  saveCreateThermometer,
  saveUpdateThermometers,
  loading,
  method,
  formValues,
}) => {

  return (
    <Dialog
      header={
        method === "create" ? "Crear Termómetro" :
          method === "update" ? "Actualizar Termómetro" : null
      }
      visible={visible}
      headerStyle={{
        backgroundColor: '#0d3b59',
        color: 'white',
        fontWeight: 'bold',
      }}
      pt={{
        header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
        headerIcon: { style: { color: 'white' } },
      }}
      onHide={() => setVisible(false)}
      className="pt-0"
      footer={null}
    >
      {(method === "create" || method === "update") && (
        <FormMicThermometer
          button={method === "create" ? "Guardar" : "Actualizar"}
          handleInputChange={handleInputChange}
          loading={loading}
          onSubmit={method === "create" ? saveCreateThermometer : saveUpdateThermometers}
          name_thermometer={formValues.name_thermometer}
          abbreviation={formValues.abbreviation}
          internal_thermometer={formValues.internal_thermometer}
          correction_factor={formValues.correction_factor}
        />
      )}
    </Dialog>
  );
};

